import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import cn from 'classnames';
import { useState } from 'react';

import AllServiceRequests from './components/AllServiceRequests';
import ClosedServiceRequests from './components/ClosedServiceRequests';

const Reports = () => {
	const [selectedTabIndex, setSelectedTabIndex] = useState(0);

	return (
		<div className="reports">
			<h1>Reports</h1>
			<TabGroup
				className="mt-4"
				selectedIndex={selectedTabIndex}
				onChange={setSelectedTabIndex}
			>
				<TabList as="nav" className="tabs tabs-bordered">
					<Tab className={cn('tab', { 'tab-active': selectedTabIndex === 0 })}>
						Closed Service Requests
					</Tab>
					<Tab className={cn('tab', { 'tab-active': selectedTabIndex === 1 })}>
						Service Request Export
					</Tab>
				</TabList>
				<TabPanels className="tab-panels">
					<TabPanel className={cn({ block: selectedTabIndex === 0 })}>
						<ClosedServiceRequests />
					</TabPanel>
					<TabPanel className={cn({ block: selectedTabIndex === 1 })}>
						<AllServiceRequests />
					</TabPanel>
				</TabPanels>
			</TabGroup>
		</div>
	);
};

export default Reports;
